


















import Vue from "vue";
import { mapGetters } from "vuex";
import { GiftcardObject } from "./types/index";
import GiftCard from "@/components/vue-components/GiftCard.vue";

export default Vue.extend({
  name: "GiftcardsDashboard",
  components: {
    GiftCard
  },
  props: {
    giftcards: {
      type: Array as () => GiftcardObject[],
      default() {
        return [];
      }
    },
    companies: {
      type: Object,
      default() {
        return {};
      }
    },
    offices: {
      type: Object,
      default() {
        return {};
      }
    },
    resources: {
      type: Object,
      default() {
        return {};
      }
    },
    services: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  methods: {}
});
